// extracted by mini-css-extract-plugin
export var blink = "_6n-2";
export var cursor = "_6n-1";
export var reactMarkdown = "_6n-3";
export var streamingText = "_6n-0";